<template>
    <v-dialog
        v-model="value"
        persistent
        max-width="518px"
        max-height="658px"
        content-class="bible-form-dialog"
    >
        <!-- dialog content -->
        <generate-form
            @save="this.close"
            @cancel="this.close"
        />
    </v-dialog>
</template>

<script>
import GenerateForm from "@/Shared/DathaGatherings/Common/Forms/GenerateForm";
import DialogMixin from "@/Shared/Dialogs/DialogMixin";

export default {
    name: "GenerateFormDialog",

    components: {GenerateForm},

    mixins: [DialogMixin],
}
</script>

<style scoped>

</style>
